import React from 'react';
import PropTypes from 'prop-types';
import { Card, Badge, Table, Row, Col } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

const OpenResponsesTable = ({ open_stats }) => {
  if (!open_stats || Object.keys(open_stats).length === 0) {
    return null;
  }

  const questionsArr = Object.values(open_stats);

  return (
    <>
      {questionsArr.map((question, idx) => (
        <Row className="g-3 mb-3" key={idx}>
          <Col xs={12}>
            <Card className="mb-2 shadow-sm">
              <FalconCardHeader
                title={question.question_text}
                light={false}
                titleTag="h5"
                className="pb-0"
                endEl={
                  <Badge bg="info" className="fs-9">
                    {question.total_answers} respuestas
                  </Badge>
                }
              />
              <Card.Body className="pt-2">
                <div style={{ maxHeight: 320, overflowY: 'auto' }}>
                  <Table
                    striped
                    bordered
                    size="sm"
                    className="mb-0"
                    style={{
                      borderWidth: 1,
                      borderColor: '#343a40',
                      borderStyle: 'solid',
                      fontSize: '0.7rem'
                    }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th
                          style={{
                            fontSize: '0.65rem',
                            fontWeight: 500,
                            padding: '0.25rem 0.5rem'
                          }}
                          className="text-center align-middle"
                        >
                          #
                        </th>
                        <th
                          className="align-middle"
                          style={{
                            fontSize: '0.65rem',
                            fontWeight: 500,
                            padding: '0.25rem 0.5rem'
                          }}
                        >
                          Respuesta
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {question.open_answers.map((answer, i) => (
                        <tr key={i}>
                          <td
                            className="text-center align-middle"
                            style={{
                              padding: '0.25rem 0.5rem',
                              fontSize: '0.7rem'
                            }}
                          >
                            {i + 1}
                          </td>
                          <td
                            className="align-middle"
                            style={{
                              padding: '0.25rem 0.5rem',
                              fontSize: '0.7rem'
                            }}
                          >
                            {answer}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ))}
    </>
  );
};

OpenResponsesTable.propTypes = {
  open_stats: PropTypes.object.isRequired
};

export default OpenResponsesTable;
